import React from 'react'
import { graphql } from 'gatsby'
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'

import { Layout } from '../components/Layout'
import { components } from '../slices'
import SliceZoneComponent from '../components/SliceZone'
import Privacy from '../components/privacy/Privacy'
import { getDefaultPageData } from '../utils/getDefaultPageData'
import { SEO } from '../components/Head'

const PrivacyPage = ({ data }) => {
  if (!data) return null

  const headerArticlesData = data.headerArticles.nodes

  const { topLine, footer, header, page, activeDoc, topMenu } =
    getDefaultPageData(data, 'prismicPrivacyPage')

  return (
    <Layout
      topMenu={topMenu.data}
      footer={footer.data}
      topLine={topLine.data}
      header={{ nav: header.data.nav, articles: header.data.articles }}
      activeDocMeta={activeDoc}
      headerArticlesData={headerArticlesData}
    >
      <Privacy
        pageTitle={page?.page_title?.text}
        corporationTitle={page?.corporation_title?.text}
        updatedTitle={page?.updated_title?.text}
        updatedDate={page?.updated_date?.text}
        policy={page?.policy?.richText}
        historyTitle={page?.history_title?.text}
        history={page?.history}
        backgroundImage={page?.background_image}
      />
      <SliceZoneComponent slices={page.body} components={components} />
    </Layout>
  )
}

export const Head = ({ data }) => {
  const { page, pageContent } = getDefaultPageData(data, 'prismicPrivacyPage')
  return (
    <SEO
      meta={{
        title: page?.meta_title,
        description: page?.meta_description,
        image: page?.meta_image,
        type: page?.type,
        pageContent,
      }}
    />
  )
}

export const query = graphql`
  query privacyPageQuery($id: String, $lang: String) {
    prismicPrivacyPage(id: { eq: $id }, lang: { eq: $lang }) {
      _previewable
      url
      uid
      type
      id
      lang
      alternate_languages {
        id
        type
        lang
        uid
      }
      data {
        meta_title {
          text
        }
        meta_image {
          url
          alt
        }
        meta_description {
          text
        }
        updated_title {
          text
        }
        updated_date {
          text
        }
        policy {
          richText
        }
        page_title {
          text
        }
        history_title {
          text
        }
        history {
          history_date {
            text
          }
        }
        corporation_title {
          text
        }
        background_image {
          gatsbyImageData
          alt
        }
        body {
          ... on PrismicSlice {
            id
            slice_label
            slice_type
            ...PrivacyPageDataBodyBusinessesAction
            ...PrivacyPageDataBodyCallToAction
          }
        }
      }
    }
    prismicTopLine(lang: { eq: $lang }) {
      ...TopLineFragment
    }
    prismicHeader(lang: { eq: $lang }) {
      data {
        articles {
          article_link {
            document {
              ... on PrismicArticlePage {
                ...ArticlePage
              }
            }
          }
        }
        nav {
          ... on PrismicSlice {
            id
            slice_type
            slice_label
          }
          ...HeaderDataNavFooter
          ...HeaderDataNavButton
          ...HeaderDataNavNavItem
        }
      }
    }
    prismicFooter(lang: { eq: $lang }) {
      data {
        body {
          ... on PrismicSlice {
            id
            slice_type
            slice_label
          }
          ...FooterDataBodyCopyright
          ...FooterDataBodyFooter
          ...FooterDataBodySocials
          ...FooterDataBodyAwards
          ...FooterDataBodyForm
        }
        body1 {
          ... on PrismicSlice {
            id
            slice_type
            slice_label
          }
          ...FooterDataBody1NavItem
        }
      }
    }
    headerArticles: allPrismicArticlePage(
      filter: {
        lang: { eq: $lang }
        data: { invisible: { eq: "no" }, type: { eq: "blog" } }
      }
      limit: 2
      sort: { first_publication_date: DESC }
    ) {
      nodes {
        ...ArticlePage
      }
    }
  }
`

export default withPrismicPreview(PrivacyPage)
